export const translate = (x: number, y: number): string =>
  `translate(${x},${y})`;
export const translateX = (x: number): string => `translate(${x},0)`;
export const translateY = (y: number): string => `translate(0,${y})`;
